import { Block } from '@mote/ui/components'
import styled from '@xstyled/styled-components'

export const Container = styled(Block).attrs({
  align: 'center',
  gap: 24,
  height: 'auto'
})`
  margin-left: auto;
  margin-right: auto;

  &::before,
  &::after {
    content: ' ';
    display: table;
    grid-column-start: 1;
    grid-row-start: 1;
    grid-column-end: 2;
    grid-row-end: 2;
  }
`
